import ReactDOM from "react-dom/client";
import { ClickToSourceExample } from "#scripts/components/demo/click-to-source-example.tsx";

const mountElement = document.getElementById("click-to-source-demo");

if (mountElement) {
  mountElement.textContent = "";
  ReactDOM.createRoot(mountElement).render(<ClickToSourceExample />);
}
